import { Component, Input } from '@angular/core';

@Component({
  selector: 'task',
  templateUrl: 'task.html'
})

export class TaskComponent {
  @Input() name: string;
  @Input() day: string;
  @Input() do: string;
  @Input() want: string;

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/components/task/task.ts